export const SET_TOPBAR_COURSE_NAVIGATION_SEARCH_STRING =
  'SET_TOPBAR_COURSE_NAVIGATION_SEARCH_STRING';

export const UPDATE_USER_PREFERRED_LANGUAGE_SUCCESS_SUCCESS =
  'UPDATE_USER_PREFERRED_LANGUAGE_SUCCESS_SUCCESS';
